import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8.755",
      cy: "9",
      r: "3.453",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".917"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "M8.755 2.644v-.977m0 14.666v-.977m6.601-6.112h.977m-14.666 0h.978m10.777-4.667.692-.691M3.743 14.257l.691-.692m-.345-8.988-.692-.691m10.371 10.371-.691-.692"
    }, null, -1)
  ]))]))
}
export default { render: render }